/**
 * Unsubscribe from all subscribtions on ngOnDestroy
 * @param props to unsubscribe - default will be all keys in object (including arrays)
 */
export function AutoUnsubscribeOnDestroy(props = []) {

  return function (constructor) {
    const original = constructor.prototype.ngOnDestroy;

    constructor.prototype.ngOnDestroy = function () {
      (props && props.length ? props : Object.keys(this)).forEach(p => {
        const property = this[p];
        if (property) {
          if (( typeof property.unsubscribe === 'function' )) {
            property.unsubscribe();
          }

          if (Array.isArray(property)) {
            property.forEach(pItem => {
              if (( typeof pItem.unsubscribe === 'function' )) {
                pItem.unsubscribe();
              }
            });
          }
        }
      });
      if (original && typeof original === 'function') {
        original.apply(this, arguments);
      }
    };
  };
}
